import { Component, OnInit, OnDestroy, Input, Output, EventEmitter  } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';

import { ProductionOrderService, ProductionOrderData, PrClient, Customer } from '../../services/production-order.service';
import { ShipService } from '../../services/ship.service';
import { EmployeeService } from '../../services/employee.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { ProductVntaService, PrVnta } from '../../services/product-vnta.service';

import { Utils } from '../../util';
import { QuotationFunctionData } from '../../quotation-activity-functions';
import { ActivityService, ActivityId, PdfActivityDisplayLabels } from '../../services/activity.service';
import { ActivityClassificationService } from '../../services/activity-classification.service';
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { UnitService } from '../../services/unit.service';
import { SuajeService } from '../../services/suaje.service';
import { MachineService } from '../../services/machine.service';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { QuotService } from '../../services/quot.service';
import { PrClientData } from '../../services/product-client.service';
import { PermissionService, SpecialPermissions } from '../../services/permission.service';

@Component({
    selector: 'app-create-production-order',
    templateUrl: './create-production-order.component.html',
    styleUrls: ['./create-production-order.component.css', '../../app.component.css']
})

export class CreateProductionOrderComponent implements OnInit, OnDestroy {
	loading: boolean[] = Array(10).fill(false);
	get loaded(): boolean { return !this.loading.includes(false); }
	permission: any = {};

	productionOrderForm: FormGroup;
	sectionForm: FormGroup;
	activityForm: FormGroup;
	productionOrder: any;

	sections: any[] = [];
	currentSectionTab: number;
	currentSectionShowing: boolean;
	sectionAppliesPrVnta: boolean = false;
	modalActionsSection = new EventEmitter<string|MaterializeAction>();
	modalParamsSection = [{dismissible: true}];
  
	generalActivities: any[] = [];
	currentActivityEdit: number;
	activityEditingObj: any = {};
	unique = {...this.productionOrderData.defaultUnique};
	uniqueInit = { papel: undefined, papelData: {}, suaje: undefined, machine: undefined, };
	selects: any = {};
	activityIsGeneral: boolean;
	activityFunction: any;
	activityDataCalc: string;
	pdfDisplay: ActivityId['pdfDisplay'] = this.activityService.defaultDisplay;
	activityRanges: any[];
	labels: string[];
	modalActionsActivity = new EventEmitter<string|MaterializeAction>();
	modalParamsActivity = [{dismissible: true}];
	quality = {...this.productionOrderData.defaultQuality};
	modalActionsQuality = new EventEmitter<string|MaterializeAction>();
	modalParamsQuality = [{dismissible: true}];
  
	activities = {};
	classifications = {};
	users = {};
  
	activitiesInit: any;
	activitiesInits: any;
	classificationInit: any;
	classificationInits: any;
  
	modalPurpose: string = 'add';
  
	activityFunctionDatas: any;
	generalfunctionSelects: any[];
	sectionfunctionSelects: any[];

    nextFolio: number;
    projectFolio = '';
    shortDesc = '';
    longDesc = '';

	printDataSelect;
	
    statusSelect;
    prClient: PrClient = {
		id: '',
        code: '',
		version: '',
		barCode: '',
		designComments: '',
		qualityComments: '',
		processOwnerComments: ''
    }
    customer: Customer = {
		id: '',
		name: '',
		purchaseOrderNumber: '',
		addressId: ''
    }

    pickadateParams = Utils.pickadateParams();
    pickatimeParams = Utils.pickatimeParams();

    subs: any[] = [];

	Object = Object;
	PdfActivityDisplayLabels = PdfActivityDisplayLabels;
    constructor(
			private fb: FormBuilder,
			private router: Router,
			private activatedRoute: ActivatedRoute,
			private productionOrderService: ProductionOrderService,
			private productionOrderData: ProductionOrderData,
			private shipService: ShipService,
			private employeeService: EmployeeService,
			private customerService: CustomerSupplierService,
			private prVntaService: ProductVntaService,
			private prCmpaService: ProductCmpaService,
			private suajeService: SuajeService,
			private unitService: UnitService,
			private machineService: MachineService,
			private userService: UserService,
			private quotationFunctionData: QuotationFunctionData,
			private activityService: ActivityService,
			private activityClassificationService: ActivityClassificationService,
			private authService: AuthService,
			private quotService: QuotService,
			private prClientData: PrClientData,
			private permissionService: PermissionService
    ) {
		let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
			permissionsSubs.unsubscribe();
			this.permission = this.permissionService.constructPermissionObject(groups, 'SPECIAL');
		});

        this.customer.id = this.activatedRoute.snapshot.paramMap.get('customerId');
        this.subs.push( this.customerService.getCustomerSupplier(this.customer.id).subscribe(c => { this.customer.name = c.name }) );
        this.statusSelect = Object.keys(productionOrderData.statusObjects).map(key => ({
            value: key,
            ...productionOrderData.statusObjects[key]
		}) );
        this.printDataSelect = Object.keys(productionOrderData.printDataSelector).map(key => ({
			value: key,
            ...productionOrderData.printDataSelector[key]
		}) );
		
		// this.printDataSelect = ['Trabajo nuevo', 'Reimpresión', 'Reimpresión con cambios', 'Reimpresión por Reproceso'];
		this.selects = {...this.prClientData.allSelects};
		
		let lastSub = this.productionOrderService.getLastProductionOrder().subscribe(tempOrders => {
			lastSub.unsubscribe();
			if (tempOrders[0] === undefined) this.nextFolio = Utils.getNextFolio('');
			else this.nextFolio = Utils.getNextFolio(tempOrders[0].projectFolio);
			this.projectFolio = 'PRD' + this.nextFolio;
			this.loading[0] = true;
		});
		this.subs.push(
			this.prVntaService.getPrVntas({onEmpty: ()=>{this.loading[1] = true; toast('Advertencia: No hay productos de venta.', 3000);} }).subscribe(prVntas => {
				this.rowsRead[0] = prVntas.map(prVnta => {
					prVnta.prTypeName = prVnta.data.name;
					this.prVntas[prVnta.id] = {...prVnta};
					return prVnta;
				});
				this.loading[1] = true;
			})
		);
		let shipSub = this.shipService.getShips({onEmpty: ()=>{ this.loading[2] = true} }).subscribe(ships => {
			shipSub.unsubscribe();
			this.rowsRead[1] = ships.map(ship => {
				ship.supervisorName = ship.supervisorObj ? ship.supervisorObj.name + ' ' + ship.supervisorObj.lastName : '';
				ship.subsidiaryName = ship.subsidiaryObj.name;
				this.ships[ship.id] = {...ship};
				return ship;
			});
			if(this.rowsRead[1].length == 1) this.selectedIds[1] = this.rowsRead[1][0].id;
			
			this.loading[2] = true;
		})
		this.subs.push(
			this.employeeService.getEmployees({onEmpty: ()=>{this.loading[3] = true; toast('Advertencia: No hay empleados.', 3000);} }).subscribe(employees => {
				this.rowsRead[2] = employees.map(({id$, ...employee}) => {
					employee.id = id$;
					employee.name = `${employee.name} ${employee.lastName}`;
					this.employees[employee.id] = {...employee};
					return employee;
				});
				this.loading[3] = true;
			})
		);

		this.sections = [];
		this.activityFunctionDatas = this.quotationFunctionData.functionData;
		this.activityFunction = {};
		this.generalfunctionSelects = [];
		this.sectionfunctionSelects = [];
		quotationFunctionData.selectArray.map(data => {
			if(data.isGeneral) this.generalfunctionSelects.push(data);
			else this.sectionfunctionSelects.push(data);
		})
	
		this.activities = {};
		this.activitiesInits = { 'section': {data: {}}, 'general': {data: {}}, };
		let subActivity = this.activityService.getActivities({onEmpty: ()=>{ this.loading[4] = true} }).subscribe(activities => {
			subActivity.unsubscribe();
			const data = activities.reduce((acc, cur) => {
				const type = cur.activityClassObj.perSection ? 'section' : 'general';
				this.activitiesInits[type].data[`${cur.name.trim()}`] = null;
				this.activities[`${cur.name.trim()}`] = {
					...cur,
					classification: cur.activityClassObj.name,
					ranges: cur.ranges || [],
					prices: cur.prices || [],
					quantityPricesFunction: cur.quantityPricesFunction || '',
					unique: cur.unique || {},
					pdfDisplay: cur.pdfDisplay || this.activityService.defaultDisplay,
					actId: cur.id
				};
				this.activities[`${cur.id}`] = this.activities[`${cur.name.trim()}`];
				return acc;
			}, {});
			this.loading[4] = true;
		});
	
		this.classifications = {};
		this.classificationInits = { 'section': {data: {}}, 'general': {data: {}}, };
		let classSub = this.activityClassificationService.getActivityClassifications({onEmpty: ()=>{ this.loading[5] = true} }).subscribe(tempClassifications => {
			classSub.unsubscribe();
			for (const idx in tempClassifications) {
				const type = tempClassifications[idx].perSection ? 'section' : 'general';
				this.classificationInits[type].data[`${tempClassifications[idx].name.trim()}`] = null;
		
				this.classifications[tempClassifications[idx].name] = { id: tempClassifications[idx].id$, isGeneral: !tempClassifications[idx].perSection };
				this.classifications[tempClassifications[idx].id$] = { name: tempClassifications[idx].name, isGeneral: !tempClassifications[idx].perSection };
			}
			this.loading[5] = true;
		});

		let unitSub = this.unitService.getUnits().subscribe(units => {
			unitSub.unsubscribe();
			let prCmpasSub = this.prCmpaService.getPrCmpas({onEmpty: ()=>{ this.loading[6] = true} }).subscribe(prCmpas => {
				const data = prCmpas.reduce((acc, cur) => {
					cur.characs = cur.characs.reduce((acc2, cur2, index) => {
						let unit = units.find(({id}) => id == cur2.unitId.id);
						let symbol = unit ? unit.symbol : '';
						return acc2 + `${index ? ', ' : ''}${cur2.name}: ${cur2.value}${symbol}`;
					}, '');
					acc[`${cur.name} - ${cur.characs}`] = null;
					this.uniqueInit.papelData[`${cur.name} - ${cur.characs}`] = cur.id;
					return acc;
				}, {});
				this.uniqueInit.papel = { 'data': data };
				this.loading[6] = true;
			});
			this.subs.push(prCmpasSub);
		});
		let suajeSub = this.suajeService.getSuajes({customerId: this.customer.id, onEmpty: ()=>{ this.loading[7] = true} }).subscribe(suajes => {
			suajeSub.unsubscribe();
			const data = suajes.reduce((acc, cur) => {
				cur.size = `La ${cur.long} x An ${cur.wide} x Al ${cur.height}`;
				acc[`${cur.code} - ${cur.size}`] = null;
				return acc;
			}, {});
			this.uniqueInit.suaje = { 'data': data };
			this.loading[7] = true;
		});
		let machineSub = this.machineService.getMachines().subscribe(machines => {
			machineSub.unsubscribe();
			let data = machines.reduce((acc, cur) => ({ [`${cur.folio} ${cur.name}`]: cur.id, ...acc }), {} );
			this.uniqueInit.machine = { 'data': data };
			this.loading[8] = true;
		});
		let userSub = this.userService.getUsers().subscribe(users => {
			userSub.unsubscribe();
			this.users = users.reduce((acc, cur) => ({[cur.id]: `${cur.name} ${cur.lastName}`, ...acc}), {} );
			this.loading[9] = true;
		});
    }

	quotId: string;
    ngOnInit() {
        this.productionOrderForm = this.fb.group({
			folio: ['', Validators.required],
			date: [this.today, Validators.required],
            shortDescription: ['', Validators.required],
			longDescription: ['', Validators.required],
			monitor: '',

			printData: ['key1', Validators.required],
            status: ['key1',Validators.required],
            quantity: ['', Validators.min(0)],
            deliveryDate: [''],
			pricePerUnit: ['', Validators.min(0)],
			pieceType: '',
			notes: ''
        });
		this.createSectionForm();
		this.createActivityForm();
		if(localStorage.quot){
			let {shortDescription, longDescription, quantity, pricePerUnit, notes, ...quot} = JSON.parse(localStorage.quot);
			delete localStorage.quot;
			this.selectedIds[0] = quot.prVntaId;
			this.selectedIds[2] = quot.employeeSignId;
			this.sections = quot.sections.map(section => ({inks: { front :  [...this.inks], back: [...this.inks] }, ...section}));
			this.generalActivities = quot.generalActivities;
			this.shortDesc = shortDescription;
			this.longDesc = longDescription;
			this.productionOrderForm.patchValue({quantity, pricePerUnit, notes});
			this.quotId = quot.id;
		}
    }
    ngOnDestroy(){
        this.subs.map((sub, index) => {
            this.subs[index].unsubscribe();
        });
	}
	
	createSectionForm(){
		this.sectionForm = this.fb.group({
		  name: ['', Validators.required],
		  width: ['', Validators.required],
		  height: ['', Validators.required],
		  sizeInPaper: ['', Validators.required],
		  pieceInSize: ['', Validators.required],
		  frontInk: ['', [Validators.required, Validators.max(8)]],
		  backInk: ['', [Validators.required, Validators.max(8)]],
		  sheetWidth: ['', Validators.required],
		  sheetHeight: ['', Validators.required],
		  numPages: ['', Validators.required],
		  pieceHeight: ['', Validators.required],
		  pieceLong: ['', Validators.required],
		  pieceWidth: ['', Validators.required],
		});
	  }
	createActivityForm() {
		this.activityForm = this.fb.group({
			name: ['', Validators.required],
			classification: ['', Validators.required],
			quantityPricesFunction: ['', Validators.required],
			status: '',
			notes: '',

			prices: this.fb.array([]),
			minRange: '',
			maxRange: '',
			rangePrice: ''
		});
	}
	get quantity(){ return this.productionOrderForm.get('quantity').value }
	get qpFunction(){ return this.activityForm.get('quantityPricesFunction').value; }

	onSubmitProductionOrder() {
		this.productionOrder = this.saveProductionOrder();

		let docId = this.productionOrderService.postProductionOrder(this.productionOrder);
		this.quotService.afh.update(`${this.quotService.collection}/${this.quotId}`, {approved: true});
		this.productionOrderService.returnFromViewTo = 'default';
		this.router.navigate(['/vw_production_order/' + docId]);
	}

	saveProductionOrder() {
			const currentDate = new Date();

			const productionOrderJson = {
				active: 1,
				createdAt: currentDate,
				updatedAt: currentDate,

				employeeId: this.selectedEmployeeId,
				longDescription: this.productionOrderForm.get('longDescription').value,
				name: this.productionOrderForm.get('folio').value,
				projectFolio: this.nextFolio,
				date: this.productionOrderForm.get('date').value,
				shipId: this.selectedShipId || '',
				shortDescription: this.productionOrderForm.get('shortDescription').value,
				monitor: this.productionOrderForm.get('monitor').value,

				printData: this.productionOrderForm.get('printData').value,
				status: this.productionOrderForm.get('status').value,
				quantity: this.productionOrderForm.get('quantity').value || 0,
				deliveryDate: this.productionOrderForm.get('deliveryDate').value || '',
				prClient: this.prClient,
				customer: this.customer,
				pricePerUnit: this.productionOrderForm.get('pricePerUnit').value || 0,
				notes: this.productionOrderForm.get('notes').value,
				pieceType: this.productionOrderForm.get('pieceType').value,
				prVntaId: this.selectedPrVntaId,
				
				sections: this.sections,
				generalActivities: this.generalActivities
			};

			return productionOrderJson;
	}

	onBlurShortDescription() {
			if (this.shortDesc !== '' && this.longDesc === '') {
					this.longDesc = this.shortDesc;
			}
	}

	//////////////////////////////////////////////////////////////////////////SECTION
	touchSection({ value, valid }: { value: any, valid: boolean }){
	  if(this.modalPurpose == 'add'){
		value.activities = [];
		value.inks = { front :  [...this.inks], back: [...this.inks] };
		this.sections.push(value);
	  }else{
		value.activities = this.sections[this.currentSectionTab].activities;
		value.inks = this.sections[this.currentSectionTab].inks;
		let {frontInk, backInk} = value;
		for(let i = 0; i < 8 ; i ++){
		  if(i >= frontInk) value.inks.front[i] = '';
		  if(i >= backInk) value.inks.back[i] = '';
		}
		this.sections[this.currentSectionTab] = value;
	  }
	  this.closeModalSection();
	}
	removeSection(index) {
	  this.sections.splice(index, 1);
	}
	changeSectionTab(index) {
	  if(this.currentSectionTab == index) this.currentSectionShowing = !this.currentSectionShowing;
	  else{
			this.currentSectionTab = index;
			this.currentSectionShowing = true;
	  }
	  console.log(this.currentSectionShowing,this.currentSectionTab);
	}
	openModalSection(action: string, index?: number) {
	  this.modalPurpose = action;
	  this.sectionAppliesPrVnta = false;
	  this.sectionForm.reset();
	  if(action == 'edit'){
		this.currentSectionShowing = true;
		this.currentSectionTab = index;
		var section = this.sections[index];
		this.sectionForm.patchValue(section);
		console.log(this.currentSectionShowing,this.currentSectionTab);
	  }
	  this.modalActionsSection.emit({ action: 'modal', params: ['open'] });
	}
	closeModalSection() {
	  this.modalActionsSection.emit({ action: 'modal', params: ['close'] });
	}
  
	get inks(){ return [...Array(8)].map((u, i) => "") }
	//////////////////////////////////////////////////////////////////////////SECTION
  
	//////////////////////////////////////////////////////////////////////////ACTIVITY
	touchActivity({ value, valid }: { value: any, valid: boolean }) {
	  var activity = {...this.productionOrderData.defaultActivity, ...this.activityEditingObj, ...value };
	  activity.actId = this.currentActId;
	  activity.dataCalc = this.activityDataCalc;
	  activity.pdfDisplay = {...this.pdfDisplay};
	  if(activity.dataCalc === 0){
			activity.ranges = this.activityRanges;
			activity.prices = [];
	  }else if(activity.dataCalc > 0){
			activity.prices = value.prices.map(object => object.price);
			activity.ranges = [];
	  }
	  activity.unique = { ...this.unique[this.qpFunction] || {} };
	  delete activity.minRange;
	  delete activity.maxRange;
	  delete activity.rangePrice;
	  let {machineName} = activity.unique;
	  if(machineName) activity.unique.machineId = this.uniqueInit.machine.data[machineName] || '';
	  let id =  this.uniqueInit.papelData[activity.unique.prCmpaDescription];
	  if(id) activity.unique.prCmpaId = id;
	  if(this.activityIsGeneral){
			if(this.modalPurpose == 'add') this.generalActivities.push(activity);
			else this.generalActivities[this.currentActivityEdit] = activity;
	  }else{
			//console.log(this.sections); // No borrar por favor :(
			if(this.modalPurpose == 'add') this.sections[this.currentSectionTab].activities.push(activity);
			else this.sections[this.currentSectionTab].activities[this.currentActivityEdit] = activity;
	  }
	  this.closeModalActivity();
	  
	}
	removeActivity(isGeneral: boolean, index: number) {
		let acts = isGeneral ? this.generalActivities : this.sections[this.currentSectionTab].activities;
		if(!confirm(`¿Borrar la actividad ${acts[index].name}?`)) return;
		acts.splice(index, 1);
	}
  
	openModalActivity(action: string, isGeneral: boolean, index?: number) {
	  this.currentActId = '';
	  while(this.prices.length > 0) this.prices.removeAt(0);
	  this.modalPurpose = action;
	  this.activityForm.reset();
	  this.activityForm.patchValue(this.productionOrderData.defaultActivity);
	  this.activityFunction = {};
	  this.activityDataCalc = '';
	  this.pdfDisplay = this.activityService.defaultDisplay;
	  this.activityRanges = [];
	  this.activityIsGeneral = isGeneral;
	  const type = isGeneral ? 'general' : 'section';
	  this.unique = {...this.productionOrderData.defaultUnique};
	  this.updateActivitiesInit(type);
	  this.updateClassificationInit(type);
	  if(action == 'edit'){
			this.currentActivityEdit = index;
			var activity = isGeneral ? this.generalActivities[index] : this.sections[this.currentSectionTab].activities[index];
			this.currentActId = activity.actId || '';
			this.activityEditingObj = {...activity};
			this.activityDataCalc = activity.dataCalc;
			this.pdfDisplay = activity.pdfDisplay || this.activityService.defaultDisplay;
			this.activityForm.patchValue(activity);
			this.activityFunction = this.activityFunctionDatas[activity.quantityPricesFunction];
			if(this.unique[this.qpFunction]) this.unique[this.qpFunction] = { ...this.unique[this.qpFunction], ...activity.unique };
			this.activityRanges = activity.ranges;
			if(activity.dataCalc > 0){
				this.labels = this.activityFunction.labels;
        [...Array(this.quotationFunctionData.functionData[this.qpFunction].dataCalc)].map((u, index) => {
        //activity.prices.map(number => {
          this.prices.push(this.fb.group({price: activity.prices[index] || 0}));
        });
			}
	  }else{
			if(this.activityIsGeneral) var array = this.generalfunctionSelects;
			else var array = this.sectionfunctionSelects;
			this.activityForm.get('quantityPricesFunction').patchValue(array[0].value);
			this.onChangeAFunction(array[0].value);
	  }
	  this.modalActionsActivity.emit({ action: 'modal', params: ['open'] });
	}
	closeModalActivity() {
	  this.modalActionsActivity.emit({ action: 'modal', params: ['close'] });
	}
  
	updateActivitiesInit(type){
	  this.activitiesInit = this.activitiesInits[type];
	}
	updateClassificationInit(type){
	  this.classificationInit = this.classificationInits[type];
	}
	
	currentActId: string = '';
	onChangeAName(name){
	  if(this.activities[name]){
		var activity = this.activities[name];
		this.currentActId = activity.actId;
		if(activity.quantityPricesFunction == 'papel') this.unique.papel.prCmpaDescription = activity.unique && activity.unique.prCmpaDescription || '';
		if(activity.quantityPricesFunction == 'papel') this.unique.papel.prCmpaId = activity.unique && activity.unique.prCmpaId || '';
		this.activityDataCalc = activity.dataCalc;
		this.pdfDisplay = activity.pdfDisplay || this.activityService.defaultDisplay;
		this.activityForm.get('classification').patchValue(activity.classification);
		this.activityForm.get('quantityPricesFunction').patchValue(activity.quantityPricesFunction);
		this.activityFunction = this.activityFunctionDatas[activity.quantityPricesFunction];
		this.activityRanges = activity.ranges;
		while(this.prices.length > 0) this.prices.removeAt(0);
		if(activity.dataCalc > 0){
		  this.labels = this.activityFunction.labels;
			[...Array(this.quotationFunctionData.functionData[this.qpFunction].dataCalc)].map((u, index) => {
			//activity.prices.map(number => {
				this.prices.push(this.fb.group({price: activity.prices[index] || 0}));
			});
		}
	  }
	}
	onChangeAFunction(functionName){
	  this.activityFunction = this.activityFunctionDatas[functionName];
	  this.activityDataCalc = this.activityFunction.dataCalc;
	  while(this.prices.length > 0) this.prices.removeAt(0); //reset prices por pushing
		  this.labels = this.activityFunction.labels;
		  if(this.activityFunction.dataCalc > 0 ) for(var i = 0; i < this.activityFunction.dataCalc; i++) this.prices.push(this.priceForm());
	}

	get activityStatusSelect(){
		let objs = this.productionOrderData.activityStatusObjects;
		return Object.keys(objs).map(key => ({value: key, name: objs[key].name}) );
	}
	onActivityStatus(aIndex: number, isGeneral: boolean){
		let act = (isGeneral ? this.generalActivities : this.sections[this.currentSectionTab].activities)[aIndex];
		act.status = this.productionOrderData.activityStatusObjects[act.status].next;
	}

	///////////////////////////////////////////////QUALITY
	curQualityAct: any = {};
	openModalQuality(isGeneral: boolean, index: number) {
		this.curQualityAct = {
			...(isGeneral ? this.generalActivities : this.sections[this.currentSectionTab].activities)[index],
			isGeneral, index
		}
		let qpFunction = this.curQualityAct.quantityPricesFunction
		this.quality[qpFunction] = { ...this.productionOrderData.defaultQuality[qpFunction], ...this.curQualityAct.quality, userId: this.authService.currentUser.id };
		this.modalActionsQuality.emit({ action: 'modal', params: ['open'] });
	}
	closeModalQuality() {
		this.modalActionsQuality.emit({ action: 'modal', params: ['close'] });
	}

	touchQuality(){
		let {index, isGeneral, quantityPricesFunction: qpf} = this.curQualityAct;
		let quality = this.quality[qpf];
		let {machineName} = quality;
		if(machineName) quality.machineId = this.uniqueInit.machine.data[machineName] || '';
		(isGeneral ? this.generalActivities : this.sections[this.currentSectionTab].activities)[index].quality = { ...quality };
		console.log(quality);
		this.closeModalQuality();
	}

	///////////////////////////////////////////////QUALITY
  
	touchActivityRange(){
	  const min = Math.abs(+this.activityForm.get('minRange').value);
	  const max = Math.abs(+this.activityForm.get('maxRange').value);
	  const price = Math.abs(+this.activityForm.get('rangePrice').value);
	  if(!isNaN(min) || !isNaN(max) || !isNaN(price)){
		this.activityRanges.push({
		  min: min,
		  max: max,
		  price: price
		});
		this.activityForm.get('minRange').reset();
		this.activityForm.get('maxRange').reset();
		this.activityForm.get('rangePrice').reset();
	  }
	}
	removeActivityRange(index){
	  this.activityRanges.splice(index,1);
	}
	get prices(): FormArray {
		  return this.activityForm.get('prices') as FormArray;
	  }
	  priceForm(){
		  return this.fb.group({
			  price: ['', Validators.required]
		  });
	}

	suajeClick(){
		if(!this.permission.prClientPreProduction) return toast(`No tiene permiso de ${SpecialPermissions.prClientPreProduction}.`, 2000);
	}
	//////////////////////////////////////////////////////////////////////////ACTIVITY

	//////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA
	selectedIds: string[] = [];
	prVntas = {};
	get selectedPrVntaId(): string { return this.selectedIds[0]; }
	ships = {};
	get selectedShipId(): string { return this.selectedIds[1]; }
	employees = {};
	get selectedEmployeeId(): string { return this.selectedIds[2]; }
	
	get readValid(){ return this.selectedPrVntaId && this.selectedEmployeeId };
	
	currentReadIndex: number;
	activityEmployeeRead: string = '';
	rowsRead = [[], [], []];
	columnsRead = [
		[//prVnta
			{title: 'Nombre', name: 'name',sort: 'asc'},
			{title: 'Descripción', name: 'description'},
			{title: 'Clasificación' , name: 'prTypeName'},
			{title: 'Código', name: 'code'},
		],
		[//ship
			{title: '#', name: 'name',sort: 'asc'},
			{title: 'Descripción', name: 'description'},
			{title: 'Supervisor', name: 'supervisorName'},
			{title: 'Lugar de Trabajo', name: 'subsidiaryName'}
		],
		[//employee
			{ title: 'Nombre', name: 'name' },
			{ title: 'Folio', name: 'internalKey', sort: 'asc' },
			{ title: 'Correo electrónico', name: 'email' }
		]
	]

	modalActionsRead = new EventEmitter<string|MaterializeAction>();
	modalParamsRead = [{dismissible: true}];
	openModalRead(index: number, isGeneral: boolean, activityIndex: number = -1, activityType: string = '') {
		this.currentReadIndex = index;
		this.activityIsGeneral = isGeneral;
		this.currentActivityEdit = activityIndex;
		this.activityEmployeeRead = activityType;
		this.data = this.rowsRead[index];
		
		this.config = this.configs[index];
	
		this.onChangeTable(this.config);
		this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
	}
	closeModalRead() {
		this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
	}
	selectRead(data: any): any{
		if(this.activityEmployeeRead){
			(this.activityIsGeneral ? this.generalActivities : this.sections[this.currentSectionTab].activities)[this.currentActivityEdit][this.activityEmployeeRead] = data.row.id;
			this.closeModalRead();
			return;
		}
		if(this.currentReadIndex == 0 && (!this.sections.length && !this.generalActivities.length ||  confirm("¿Desea importarlas secciones y actividades?\nEsto borrará las actuales.")) ){
			this.sections = this.prVntas[data.row.id].sections.map(section => ({
			  inks: { front :  [...this.inks], back: [...this.inks] },
				...section,
				activities: section.activities.map(ac => ({...this.productionOrderData.defaultActivity, ...ac}) )
			}) );
			this.generalActivities = this.prVntas[data.row.id].generalActivities.map(ac => ({...this.productionOrderData.defaultActivity, ...ac}) );
		}
		this.selectedIds[this.currentReadIndex] = data.row.id;
		this.closeModalRead();
	}
	unselectRead(index: number){
		this.closeModalRead();
		this.selectedIds[index] = '';
	}


	data:Array<any>;
	rows:Array<any> = [];
	page:number = 1;
	itemsPerPage:number = 5;
	maxSize:number = 5;
	numPages:number = 1;
	length:number = 0;

	config;
	configs:any = this.columnsRead.map(columns => ({
		paging: true,
		sorting: {columns: columns},
		filtering: {filterString: ''}
	}));

	/*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
		let start = (page.page - 1) * page.itemsPerPage;
		let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
		return data.slice(start, end);
	}

	changeSort(data:any, config:any):any {
		if (!config.sorting) {
			return data;
		}

		let columns = this.config.sorting.columns || [];
		let columnName:string;
		let sort:string;

		for (let i = 0; i < columns.length; i++) {
			if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
				columnName = columns[i].name;
				sort = columns[i].sort;
			}
		}

		if (!columnName) {
			return data;
		}

		// simple sorting
		return data.sort((previous:any, current:any) => {
			if (previous[columnName] > current[columnName]) {
				return sort === 'desc' ? -1 : 1;
			} else if (previous[columnName] < current[columnName]) {
				return sort === 'asc' ? -1 : 1;
			}
			return 0;
		});
	}

	changeFilter(data:any, config:any):any {
		let filteredData:Array<any> = data;
		this.columnsRead[this.currentReadIndex].forEach((column:any) => {
			if (column.filtering) {
				filteredData = filteredData.filter((item:any) => {
					return item[column.name].match(column.filtering.filterString);
				});
			}
		});

		if (!config.filtering) {
			return filteredData;
		}

		if (config.filtering.columnName) {
			return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
		}

		let tempArray:Array<any> = [];
		filteredData.forEach((item:any) => {
			let flag = false;
			this.columnsRead[this.currentReadIndex].forEach((column:any) => {
				if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
					flag = true;
				}
			});
			if (flag) {
				tempArray.push(item);
			}
		});
		filteredData = tempArray;

		return filteredData;
	}

	onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
		if (config.filtering) {
			Object.assign(this.config.filtering, config.filtering);
		}

		if (config.sorting) {
			Object.assign(this.config.sorting, config.sorting);
		}

		let filteredData = this.changeFilter(this.data, this.config);
		let sortedData = this.changeSort(filteredData, this.config);
		this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
		this.length = sortedData.length;
	}

	//////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

  get today(){
    var today = new Date();
    var dd:string = today.getDate() + '';
    var mm:string = today.getMonth()+ 1 + '';
    var yyyy = today.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }
  
  money = Utils.money;
}
